<script setup lang="ts">
import DLogo from '../../design/components/DLogo.vue';
</script>

<template>
  <div class="auth-page">
    <div class="auth-panel">
      <RouterLink to="/" class="auth-page__brand" aria-label="Dometry"><DLogo full /></RouterLink>
      <slot />
    </div>
  </div>
</template>
